import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import driverIcon from "../../../../assets/images/red-car.png";
import { getImageByType } from "../../../../models/map/enum";
import { IResponseTracking } from "../../../../models/map/response";
import { MAP_DEFAULT_LOCATION } from "../../../../utils/helpers/constants";
import Spin from "../../antd/spin";
import styles from "./style.module.scss";
import { IStore } from "../../../../models/store/response";
import { getStorWorkingStatus } from "../../../../models/store/enum";
import { getVehicleIcon } from "../../../../models/delivery-workers/enum";

interface IProps {
  location?: IResponseTracking[];
  selectedDriver?: IResponseTracking;
  setSelectedDriver?: (val: IResponseTracking) => void;
  stores?: IStore[];
  width?: string;
  height?: string;
}

const ViewMarkers: React.FC<IProps> = ({
  location,
  width,
  height,
  stores,
  selectedDriver,
  setSelectedDriver,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hover, setHover] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState<IResponseTracking>(null);
  const [selectedStoreMarker, setSelectedStoreMarker] = useState<IStore>(null);
  const { t } = useTranslation();
  const { isLoaded: isApiLoaded } = useJsApiLoader({
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_KEY}`,
    libraries: ["drawing"],
  });
  const containerStyle = {
    width: width ?? "78vw",
    height: height ?? "55vh",
  };
  const handleMarkerClick = (marker: IResponseTracking | IStore) => {
    //@ts-ignore
    setSelectedMarker(marker);
  };

  const [center, setCenter] = useState({
    lat: selectedMarker
      ? selectedMarker?.latitude
      : location?.[0]
      ? location?.[0].latitude
      : stores[0]?.location?.coordinates[1],
    lng: selectedMarker
      ? selectedMarker?.longitude
      : location?.[0]
      ? location?.[0].longitude
      : stores[0]?.location?.coordinates[0],
  });

  React.useEffect(() => {
    setIsLoaded(isApiLoaded);
  }, [isApiLoaded]);
  React.useEffect(() => {
    if (selectedDriver) {
      setSelectedMarker(selectedDriver);

      setCenter({
        lat: selectedDriver?.latitude,
        lng: selectedDriver?.longitude,
      });
    }
  }, [selectedDriver]);

  return (
    <>
      {!isLoaded ? (
        <>
          <Spin />
        </>
      ) : (
        <>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
          >
            {selectedMarker && (
              <InfoWindow
                position={{
                  lat: selectedMarker
                    ? selectedMarker?.latitude
                    : MAP_DEFAULT_LOCATION.lat,
                  lng: selectedMarker
                    ? selectedMarker?.longitude
                    : MAP_DEFAULT_LOCATION.lng,
                }}
                onCloseClick={() => {
                  setSelectedMarker(null);
                  setSelectedDriver(null);
                }}
              >
                <div className={styles?.container}>
                  <strong>
                    {t("first_name")} :
                    {selectedMarker?.user_data?.info_payload?.firstName}
                  </strong>
                  <strong>
                    {t("last_name")} :
                    {selectedMarker?.user_data?.info_payload?.lastName}
                  </strong>
                  <strong>
                    {t("mobile")} :
                    {selectedMarker?.user_data?.info_payload?.mobile}
                  </strong>
                  <strong>
                    {t("phone")} :
                    {selectedMarker?.user_data?.info_payload?.phone}
                  </strong>
                  <strong>
                    {t("email")} :
                    {selectedMarker?.user_data?.info_payload?.email}
                  </strong>
                  {/* <div>
                    <Tag
                      title={getStorStatus(selectedMarker?.status)}
                      color={getStoreStatusColor(selectedMarker?.status)}
                    />
                  </div> */}
                </div>
              </InfoWindow>
            )}
            {selectedStoreMarker && (
              <InfoWindow
                position={{
                  lat: selectedStoreMarker
                    ? selectedStoreMarker?.location?.coordinates[1]
                    : MAP_DEFAULT_LOCATION.lat,
                  lng: selectedStoreMarker
                    ? selectedStoreMarker?.location?.coordinates[0]
                    : MAP_DEFAULT_LOCATION.lng,
                }}
                onCloseClick={() => setSelectedStoreMarker(null)}
              >
                <div>
                  <div className={styles?.container}>
                    <strong>
                      {t("name")} :{"  "}
                      {selectedStoreMarker?.name}
                    </strong>{" "}
                    <strong>
                      {t("phone")} :{"  "}
                      {selectedStoreMarker?.firstPhone}
                    </strong>
                    <strong>
                      {t("start_working_time")} :{"  "}
                      {selectedStoreMarker?.startWorkingTime}
                    </strong>{" "}
                    <strong>
                      {t("end_working_time")} :{"  "}
                      {selectedStoreMarker?.endWorkingTime}
                    </strong>
                    <strong>
                      {t("work_status")} :{"  "}
                      {t(getStorWorkingStatus(selectedStoreMarker?.workStatus))}
                    </strong>{" "}
                    <strong>
                      {t("pharmacy_promotion")} : {"  "}
                      {selectedStoreMarker?.pharmacyPromotion
                        ? t("yes")
                        : t("no")}
                    </strong>
                    {/* <div>
                    <Tag
                      title={getStorStatus(selectedMarker?.status)}
                      color={getStoreStatusColor(selectedMarker?.status)}
                    />
                  </div> */}
                  </div>{" "}
                </div>
              </InfoWindow>
            )}
            {location?.map((mark, index) => {

              return (
                <Marker
                  key={index}
                  position={{
                    lat: mark?.latitude,
                    lng: mark?.longitude,
                  }}
                  onClick={async () => {
                    await handleMarkerClick(mark);
                    setHover(true);
                  }}
                  label={{
                    text: mark?.user_data
                      ? t(
                          mark?.user_data.info_payload.firstName +
                            " " +
                            mark?.user_data.info_payload.lastName
                        )
                      : t("location"),
                    className: `${styles.marker}`,
                  }}
          
                  icon={{
                    url: getVehicleIcon(mark?.user_data.info_payload.driver.vehicleType,mark?.user_data.info_payload.driver.statusWorker),
                    scaledSize: new window.google.maps.Size(60, 60), // Adjust the size as needed
                  }}
                />
              );
            })}
            {stores?.map((mark, index) => {
              const color = mark?.operationStoreCategory?.color ?? "#FF0000";
              const isPromoted = mark?.pharmacyPromotion;
              const markerColor = isPromoted ? "#000" : "#FFF"; 

                const svg = `
                  <svg width="47" height="59" viewBox="0 0 47 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_246_1330)">
                    <mask id="mask0_246_1330" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="47" height="59">
                    <path d="M46.7926 0H0V59H46.7926V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_246_1330)">
                    <path d="M46.7955 23.3977C46.7955 32.1957 41.9328 39.8553 34.7499 43.8426L24.7817 58.269C24.6279 58.4943 24.4215 58.6786 24.1803 58.8059C23.9391 58.9333 23.6705 58.9999 23.3977 58.9999C23.125 58.9999 22.8564 58.9333 22.6152 58.8059C22.374 58.6786 22.1676 58.4943 22.0138 58.269L12.0456 43.8426C4.86273 39.8553 0 32.1957 0 23.3977C0 10.4767 10.4796 0 23.3977 0C36.3159 0 46.7955 10.4767 46.7955 23.3977Z" fill="${color}"/>
                    <path d="M23.3981 38.5897C31.7885 38.5897 38.5902 31.788 38.5902 23.3976C38.5902 15.0073 31.7885 8.20557 23.3981 8.20557C15.0078 8.20557 8.20605 15.0073 8.20605 23.3976C8.20605 31.788 15.0078 38.5897 23.3981 38.5897Z" fill="${markerColor}"/>
                    <path d="M27.8805 16.1284L22.4916 13.2289C21.9193 12.9237 21.2421 12.9237 20.6698 13.2289L15.2904 16.1284C14.8994 16.3478 14.6514 16.7675 14.6514 17.2253C14.6514 17.6926 14.8898 18.1123 15.2904 18.3222L20.6793 21.2216C20.9655 21.3742 21.2803 21.4506 21.5855 21.4506C21.8907 21.4506 22.215 21.3742 22.4916 21.2216L27.8805 18.3222C28.2715 18.1123 28.5195 17.6926 28.5195 17.2253C28.5195 16.7675 28.2715 16.3478 27.8805 16.1284Z" fill="${color}"/>
                    <path d="M19.791 22.2324L14.7836 19.7335C14.3926 19.5332 13.9538 19.5618 13.5818 19.7811C13.2194 20.0101 13 20.4011 13 20.8303V25.5612C13 26.3814 13.4578 27.1158 14.1923 27.4878L19.1996 29.9868C19.3713 30.0726 19.5621 30.1203 19.7529 30.1203C19.9722 30.1203 20.2011 30.0535 20.4014 29.939C20.7639 29.7101 20.9832 29.319 20.9832 28.8899V24.1591C20.9737 23.3388 20.5159 22.6044 19.791 22.2324Z" fill="${color}"/>
                    <path d="M30.169 20.8303V23.1767C29.7112 23.0431 29.2247 22.9859 28.7383 22.9859C27.4412 22.9859 26.1726 23.4342 25.1712 24.2353C23.7977 25.3132 23.0156 26.9441 23.0156 28.7086C23.0156 29.176 23.0728 29.6433 23.1968 30.0916C23.0537 30.0726 22.9107 30.0153 22.7771 29.9295C22.4147 29.7101 22.1953 29.319 22.1953 28.8899V24.1591C22.1953 23.3388 22.6531 22.6044 23.378 22.2324L28.3854 19.7335C28.7765 19.5332 29.2152 19.5618 29.5872 19.7811C29.9496 20.0101 30.169 20.4011 30.169 20.8303Z" fill="${color}"/>
                    <path d="M32.0575 25.9898C31.2754 25.0265 30.0831 24.416 28.7383 24.416C27.7273 24.416 26.7926 24.769 26.0581 25.3603C25.0662 26.1424 24.4463 27.3537 24.4463 28.7081C24.4463 30.0529 25.0567 31.2452 26.02 32.0273C26.7544 32.6377 27.7082 33.0001 28.7383 33.0001C29.8256 33.0001 30.808 32.59 31.5711 31.9319C32.4581 31.1402 33.0303 29.9957 33.0303 28.7081C33.0303 27.678 32.6679 26.7242 32.0575 25.9898ZM29.7207 28.9751C29.7207 29.2231 29.5872 29.4616 29.3773 29.5856L28.0325 30.3868C27.9181 30.4535 27.7941 30.4917 27.6605 30.4917C27.4221 30.4917 27.1837 30.3677 27.0501 30.1483C26.8498 29.8049 26.9547 29.3662 27.2981 29.1659L28.2901 28.5745V27.3728C28.2901 26.9818 28.6143 26.6575 29.0054 26.6575C29.3965 26.6575 29.7207 26.9818 29.7207 27.3728V28.9751Z" fill="${color}"/>
                    </g>
                    </g>
                    <defs>
                    <clipPath id="clip0_246_1330">
                    <rect width="47" height="59" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                  `;
                const encoded = encodeURIComponent(svg).replace(/'/g, "%27").replace(/"/g, "%22");
              return (
                <Marker
                  key={index}
                  position={{
                    lat: mark?.location?.coordinates[1],
                    lng: mark?.location?.coordinates[0],
                  }}
                  onClick={async () => {
                    setSelectedStoreMarker(mark);
                  }}
                  label={{
                    text: mark ? t(mark?.name) : t("location"),
                    className: `${styles.marker}`,
                  }}
                  icon={{
                    url: `data:image/svg+xml;charset=UTF-8,${encoded}`,
                    scaledSize: new window.google.maps.Size(40, 40), // Adjust the size as needed
                  }}
                />
              );
            })}
          </GoogleMap>
        </>
      )}
    </>
  );
};

export default React.memo(ViewMarkers);
